import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from 'helpers/api'
import { toast } from "react-toastify";
import { t } from 'i18next';

export const userRequests = createAsyncThunk('request/list', async (_, { dispatch }) => {
  try {
    const response = await api.get("mobile/request/user");
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

export const createRequest = createAsyncThunk('request/create', async (params, { dispatch }) => {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  try {
    const response = await api.post("mobile/request/new", params, config);
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

export const deleteRequest = createAsyncThunk('request/request', async (params, { dispatch }) => {
  try {
    const response = await api.delete("mobile/request/delete/" + params);
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

const initialState = {
  user: false,
  selected: false,
};

export const requestSlice = createSlice({
  name: "request",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(userRequests.fulfilled, (state, action) => {
      state.user = action.payload.Data
    })
  }
});

export default requestSlice.reducer;
